import { render } from "./FilterProductType.vue?vue&type=template&id=3d92b45c"
import script from "./FilterProductType.vue?vue&type=script&lang=js"
export * from "./FilterProductType.vue?vue&type=script&lang=js"
script.render = render

export default script